import { FC } from 'react';

import {
  PublicResourceIconLink,
  ResourceLinkList,
} from '@/components/ResourceLinkList';

interface RelationshipsProps {
  links: PublicResourceIconLink[] | undefined;
}

export const ResourcePanelDetailsRelationships: FC<RelationshipsProps> = ({
  links,
}) => {
  if (!links) return null;

  const referenceLinks = links.filter((link) => link.isReferenced);

  return (
    <div>
      <div className="m-6">
        <h2 className="text-xs font-medium text-fgDecorative">Referenced by</h2>
        <div className="mt-4">
          <ResourceLinkList links={referenceLinks} alternateColors />
        </div>
      </div>
    </div>
  );
};
